export default "__VITE_ASSET__Ch01Vzhl__"